import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Primary, Text } from "@cinch-labs/design-system";
import { useAnalytics } from "@cinch-nx/shared-analytics";
import { useRouter } from "next/router";
import { supportContactContent } from "../../data/content";
import { handleTrackingClick } from "../../helpers/helpers";
import styles from "./support-pre-footer.module.css";
const SupportPreFooter = ()=>{
    const router = useRouter();
    const { trackEvent  } = useAnalytics();
    const { footerCta , footerHeading  } = supportContactContent;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("section", {
            className: styles.ctaContainer,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.textWrapper,
                    children: /*#__PURE__*/ _jsx(Text, {
                        element: "h2",
                        fontSize: "m",
                        fontWeight: "semibold",
                        children: footerHeading
                    })
                }),
                /*#__PURE__*/ _jsx(Primary, {
                    onClick: ()=>{
                        handleTrackingClick(trackEvent, {
                            eventName: "click",
                            category: "button",
                            label: footerCta
                        });
                        router.push("/used-cars");
                    },
                    children: footerCta
                })
            ]
        })
    });
};
export default SupportPreFooter;
